import item1 from 'assets/img/lotteryRewards/item_1.png';
import item2 from 'assets/img/lotteryRewards/item_2.png';
import item3 from 'assets/img/lotteryRewards/item_3.png';
import item4 from 'assets/img/lotteryRewards/item_4.png';
import item5 from 'assets/img/lotteryRewards/item_5.png';
import item6 from 'assets/img/lotteryRewards/item_6.png';
import item7 from 'assets/img/lotteryRewards/item_7.png';
import item8 from 'assets/img/lotteryRewards/item_8.png';
import item9 from 'assets/img/lotteryRewards/item_9.png';

export interface IPrizeItemConfig {
    count: number;
    id: string;
    imageUrl: string;
    itemNameKey: string;
}

export interface IPrizeBlockConfig {
    minTickets: number;
    maxTickets: number;
    descKey: string;
    items: IPrizeItemConfig[];
}

export const prizes: IPrizeBlockConfig[] = [
    {
        minTickets: 1,
        maxTickets: 2,
        descKey: 'prize.tier1.desc',
        items: [
            {
                id: 'headphones',
                imageUrl: item1,
                count: 10,
                itemNameKey: 'prize.headphones.name'
            },
            {
                id: 'promo.tier1',
                imageUrl: item8,
                count: 128,
                itemNameKey: 'promo.tier1.name'
            }
        ]
    },
    {
        minTickets: 3,
        maxTickets: 4,
        descKey: 'prize.tier2.desc',
        items: [
            {
                id: 'smartwatch',
                imageUrl: item2,
                itemNameKey: 'prize.smartwatch.name',
                count: 10
            },
            {
                id: 'promo.tier2',
                imageUrl: item8,
                count: 127,
                itemNameKey: 'promo.tier2.name'
            },
            {
                id: 'prostokvashino_cert',
                imageUrl: item8,
                count: 10,
                itemNameKey: 'Сертификат 3&nbsp;000&nbsp;₽ от Простоквашино'
            }
        ]
    },
    {
        minTickets: 5,
        maxTickets: 6,
        descKey: 'prize.tier3.desc',
        items: [
            {
                id: 'blender',
                imageUrl: item3,
                itemNameKey: 'prize.blender.name',
                count: 5
            },
            {
                id: 'coffemaker',
                imageUrl: item4,
                itemNameKey: 'prize.coffemaker.name',
                count: 5
            },
            {
                id: 'parfum',
                imageUrl: item9,
                count: 10,
                itemNameKey: 'Авторский парфюм «S Parfum Exclusive»'
            },
            {
                id: 'promo.tier3',
                imageUrl: item8,
                count: 50,
                itemNameKey: 'promo.tier3.name'
            }
        ]
    },
    {
        minTickets: 7,
        maxTickets: 7,
        descKey: 'prize.tier4.desc',
        items: [
            {
                id: 'vaccumcleaner',
                imageUrl: item5,
                itemNameKey: 'prize.vaccumcleaner.name',
                count: 5
            },
            {
                id: 'multicooker',
                imageUrl: item6,
                itemNameKey: 'prize.multicooker.name',
                count: 5
            },
            {
                id: 'ozon',
                imageUrl: item7,
                itemNameKey: 'prize.ozon.name',
                count: 15
            }
            // {
            //     id: 'promo.tier4',
            //     imageUrl: item8,
            //     count: 20,
            //     itemNameKey: 'promo.tier4.name'
            // }
        ]
    }
];

export const superprizeTickets = 8;
